var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { resets } from "@recoil/Store";
import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import * as Const from "@utils/Const";
export default function MenuUpdate(props) {
    const { item, setItem } = props;
    const setReset = useSetRecoilState(resets);
    let token = localStorage.getItem(Const.TOKEN);
    const [items, setItems] = useState(null);
    const [name, setName] = useState("");
    const [url, setUrl] = useState("");
    const [isActive, setIsActive] = useState(false);
    let menuId = item.depth2 ? item.depth2.menuId : item.depth1.menuId;
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/admin/menu/${menuId}`,
        appQuery: {},
        userToken: token,
        watch: menuId,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                setItems(data.body);
                setName(!data.body.name ? "" : data.body.name);
                setUrl(!data.body.url ? "" : data.body.url);
                setIsActive(data.body.isActive);
            }
        }
    }, [data]);
    const handleView = (type) => {
        setItem(Object.assign(Object.assign({}, item), { type: type }));
    };
    const MenuUpdates = (e) => __awaiter(this, void 0, void 0, function* () {
        var isOk = confirm(`해당 메뉴를 수정하시겠습니까?`);
        if (!isOk)
            return;
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_PUT,
            appPath: `/admin/menu/${items.menuId}`,
            appQuery: {
                name: name,
                url: url,
                isActive: isActive,
            },
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                alert("수정되었습니다.");
                handleView(Const.TYPE_V);
                setReset(true);
            }
            else {
                alert(data.body.message);
            }
        }
    });
    return (_jsx(_Fragment, { children: items &&
            _jsxs("section", Object.assign({ className: "board-main" }, { children: [_jsx("h2", { children: "\uBA54\uB274 \uC218\uC815" }), items.depth > 1 &&
                        _jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC0C1\uC704ID" }), _jsx("input", { type: "text", disabled: true, value: items.parent.menuId })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC0C1\uC704 \uBA54\uB274" }), _jsx("input", { type: "text", disabled: true, value: items.parent.menuName })] }))] }), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "ID" }), _jsx("input", { type: "text", disabled: true, value: items.menuId })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uBA54\uB274\uBA85" }), _jsx("input", { type: "text", value: name, onChange: (e) => setName(e.target.value) })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "URL" }), _jsx("input", { type: "text" /* disabled={(!items.parent)&&(items.url === Const.URL_PRODUCTS || items.url === Const.URL_NOTICE) ? true : false} */, value: url, onChange: (e) => setUrl(e.target.value) })] })), _jsxs("div", Object.assign({ className: "footer-row" }, { children: [_jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "active", checked: isActive, onChange: (e) => setIsActive(e.target.checked) }), " \uBA54\uB274 \uD65C\uC131\uD654"] }), _jsxs("div", Object.assign({ className: "btn-group" }, { children: [_jsx("button", Object.assign({ className: "edit-btn", onClick: (e) => MenuUpdates(e) }, { children: "\uC800\uC7A5" })), _jsx("button", Object.assign({ className: "delete-btn", onClick: (e) => handleView(Const.TYPE_V) }, { children: "\uCDE8\uC18C" }))] }))] }))] })) }));
}
